import { render, staticRenderFns } from "./CreateSample.vue?vue&type=template&id=531dd526"
import script from "./CreateSample.vue?vue&type=script&lang=js"
export * from "./CreateSample.vue?vue&type=script&lang=js"
import style0 from "./CreateSample.vue?vue&type=style&index=0&id=531dd526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports